import React from "react";
import BarrierBreaker from "../../img/BarrierBreakerInd.png";
import BaseDest from "../../img/BaseInd.png";
import Critical from "../../img/CriticalInd.png";
import SurgeAtt from "../../img/SurgeAttInd.png";
import Freeze from "../../img/FreezeInd.png";
import Curse from "../../img/CurseInd.png";
import Warp from "../../img/WarpInd.png";
import Knockback from "../../img/KnockbackInd.png";
import LongDist from "../../img/LongDistInd.png";
import Multihit from "../../img/MultiHitInd.png";
import Omnistrike from "../../img/OmniStrikeInd.png";
import ResistFreeze from "../../img/ResistFreezeInd.png";
import ResistKnockback from "../../img/ResistKnockbackInd.png";
import ResistSlow from "../../img/ResistSlowInd.png";
import ResistWarp from "../../img/ResistWarpInd.png";
import ResistWeaken from "../../img/ResistWeakenInd.png";
import Slow from "../../img/SlowInd.png";
import Strengthen from "../../img/StrengthenInd.png";
import Survive from "../../img/SurviveInd.png";
import UnharmedWaves from "../../img/UnharmWavesInd.png";
import WaveAtt from "../../img/WaveAttInd.png";
import Weaken from "../../img/WeakenInd.png";
import Dodge from "../../img/DodgeInd.png";
import SavageBlow from "../../img/SavageBlowInd.png";
import MiniWave from "../../img/MiniWaveInd.png";
import Burrow from "../../img/BurrowInd.png";
import Toxic from "../../img/ToxicInd.png";
import Revive from "../../img/ReviveInd.png";
import Shield from "../../img/ShieldInd.png";
import DeathSurge from "../../img/DeathSurgeInd.png";

const enemyabilitylist = [
  {
    text: "Long Distance",
    value: "Long Distance",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={LongDist}
        placeholder="Long Distance"
        alt="Long Distance"
      />
    ),
  },
  {
    text: "Slow",
    value: "to slow",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Slow}
        placeholder="Slow"
        alt="Slow"
      />
    ),
  },
  {
    text: "Knockback",
    value: "of knockback",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Knockback}
        placeholder="Knockback"
        alt="Knockback"
      />
    ),
  },
  {
    text: "Freeze",
    value: "to freeze",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Freeze}
        placeholder="Freeze"
        alt="Freeze"
      />
    ),
  },
  {
    text: "Weaken",
    value: "to weaken",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Weaken}
        placeholder="Weaken"
        alt="Weaken"
      />
    ),
  },
  {
    text: "Survive",
    value: "Survive",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Survive}
        placeholder="Survive"
        alt="Survive"
      />
    ),
  },
  {
    text: "Base Destroyer",
    value: "Base Destroyer",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={BaseDest}
        placeholder="Base Destroyer"
        alt="Base Destroyer"
      />
    ),
  },
  {
    text: "Critical",
    value: "Critical",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Critical}
        placeholder="Critical"
        alt="Critical"
      />
    ),
  },
  {
    text: "Omnistrike",
    value: "Omnistrike",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Omnistrike}
        placeholder="Omnistrike"
        alt="Omnistrike"
      />
    ),
  },
  {
    text: "Wave Attack",
    value: "Wave attack",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={WaveAtt}
        placeholder="Wave Attack"
        alt="Wave Attack"
      />
    ),
  },
  {
    text: "Strengthen",
    value: "Strengthen",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Strengthen}
        placeholder="Strengthen"
        alt="Strengthen"
      />
    ),
  },
  {
    text: "Multi-hit Attack",
    value: "Multi-hit",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Multihit}
        placeholder="Multi-hit"
        alt="Multi-hit"
      />
    ),
  },

  {
    text: "Freeze Immune",
    value: "Freeze immune",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistFreeze}
        placeholder="Freeeze immune"
        alt="Freeeze immune"
      />
    ),
  },
  {
    text: "Slow Immune",
    value: "Slow immune",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistSlow}
        placeholder="Slow immune"
        alt="Slow immune"
      />
    ),
  },
  {
    text: "Weaken Immune",
    value: "Weaken immune",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistWeaken}
        placeholder="Weaken immune"
        alt="Weaken immune"
      />
    ),
  },
  {
    text: "Knockback Immune",
    value: "Knockback immune",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistKnockback}
        placeholder="Knockback immune"
        alt="Knockback immune"
      />
    ),
  },
  {
    text: "Wave Immune",
    value: "Wave immune",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={UnharmedWaves}
        placeholder="Wave immune"
        alt="Wave immune"
      />
    ),
  },
  {
    text: "Warp Immune",
    value: "Warp immune",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistWarp}
        placeholder="Warp immune"
        alt="Warp immune"
      />
    ),
  },
  {
    text: "Barrier",
    value: "Barrier",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={BarrierBreaker}
        placeholder="Barrier"
        alt="Barrier"
      />
    ),
  },
  {
    text: "Dodge",
    value: "Dodge",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Dodge}
        placeholder="Dodge"
        alt="Dodge"
      />
    ),
  },
  {
    text: "Curse",
    value: "Curse",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Curse}
        placeholder="Curse"
        alt="Curse"
      />
    ),
  },
  {
    text: "Savage Blow",
    value: "Savage Blow",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={SavageBlow}
        placeholder="Savage Blow"
        alt="Savage Blow"
      />
    ),
  },
  {
    text: "Mini-Wave",
    value: "Mini-Wave",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={MiniWave}
        placeholder="Mini-Wave"
        alt="Mini-Wave"
      />
    ),
  },
  {
    text: "Surge Attack",
    value: "Surge Attack",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={SurgeAtt}
        placeholder="Surge Attack"
        alt="Surge Attack"
      />
    ),
  },
  {
    text: "Burrow",
    value: "Burrow",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Burrow}
        placeholder="Burrow"
        alt="Burrow"
      />
    ),
  },
  {
    text: "Warp",
    value: "Warp",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Warp}
        placeholder="Warp"
        alt="Warp"
      />
    ),
  },
  {
    text: "Toxic",
    value: "Toxic",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Toxic}
        placeholder="Toxic"
        alt="Toxic"
      />
    ),
  },
  {
    text: "Revive",
    value: "Revive",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Revive}
        placeholder="Revive"
        alt="Revive"
      />
    ),
  },
  {
    text: "Dodge",
    value: "Dodge",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Dodge}
        placeholder="Dodge"
        alt="Dodge"
      />
    ),
  },
  {
    text: "Shield",
    value: "Shield",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Shield}
        placeholder="Shield"
        alt="Shield"
      />
    ),
  },
  {
    text: "Surge on Death",
    value: "Surge on Death",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={DeathSurge}
        placeholder="Surge on Death"
        alt="Surge on Death"
      />
    ),
  },
];

export default enemyabilitylist;



// WEBPACK FOOTER //
// ./src/components/utilities/enemyabilitylist.js